import { API_BASE } from '../services/api.js';
const API_BASE_URL = API_BASE;
export default API_BASE_URL;